import {
  detectPaymentCardBrand,
  paymentCardBrandLabel,
  type PaymentCardBrand,
} from '../utils/paymentCardBrand';
import styles from './PaymentCardBrandIcon.module.css';

type PaymentCardBrandIconProps = {
  /** Full/partial PAN, or omit when `brand` is provided. */
  cardNumber?: string;
  brand?: PaymentCardBrand | null;
  className?: string;
  /** Accessible name; defaults to brand label. */
  title?: string;
};

export function PaymentCardBrandIcon({
  cardNumber,
  brand: brandProp,
  className,
  title,
}: PaymentCardBrandIconProps) {
  const brand = brandProp ?? detectPaymentCardBrand(cardNumber ?? '');
  const label = title ?? paymentCardBrandLabel(brand);
  const rootClass = [styles.icon, styles[`brand_${brand}`], className].filter(Boolean).join(' ');

  return (
    <span className={rootClass} role="img" aria-label={label} title={label}>
      {brand === 'visa' ? (
        <svg viewBox="0 0 48 32" width="40" height="26" aria-hidden>
          <rect width="48" height="32" rx="4" fill="#1A1F71" />
          <text
            x="24"
            y="21"
            textAnchor="middle"
            fill="#fff"
            fontSize="11"
            fontWeight="700"
            fontFamily="Arial, Helvetica, sans-serif"
            letterSpacing="0.5"
          >
            VISA
          </text>
        </svg>
      ) : brand === 'mastercard' ? (
        <svg viewBox="0 0 48 32" width="40" height="26" aria-hidden>
          <rect width="48" height="32" rx="4" fill="#111" />
          <circle cx="19" cy="16" r="8" fill="#EB001B" />
          <circle cx="29" cy="16" r="8" fill="#F79E1B" />
          <path d="M24 9.5a8 8 0 0 1 0 13 8 8 0 0 1 0-13z" fill="#FF5F00" />
        </svg>
      ) : brand === 'amex' ? (
        <svg viewBox="0 0 48 32" width="40" height="26" aria-hidden>
          <rect width="48" height="32" rx="4" fill="#2E77BC" />
          <text
            x="24"
            y="20"
            textAnchor="middle"
            fill="#fff"
            fontSize="8"
            fontWeight="700"
            fontFamily="Arial, Helvetica, sans-serif"
          >
            AMEX
          </text>
        </svg>
      ) : brand === 'diners' ? (
        <svg viewBox="0 0 48 32" width="40" height="26" aria-hidden>
          <rect width="48" height="32" rx="4" fill="#0079BE" />
          <circle cx="24" cy="16" r="9" fill="none" stroke="#fff" strokeWidth="1.5" />
          <path d="M20 10.5v11M28 10.5v11" stroke="#fff" strokeWidth="1.5" />
        </svg>
      ) : brand === 'discover' ? (
        <svg viewBox="0 0 48 32" width="40" height="26" aria-hidden>
          <rect width="48" height="32" rx="4" fill="#fff" stroke="#ddd" />
          <text
            x="16"
            y="19"
            fill="#111"
            fontSize="7"
            fontWeight="700"
            fontFamily="Arial, Helvetica, sans-serif"
          >
            DISC
          </text>
          <circle cx="38" cy="16" r="6" fill="#F76F1B" />
        </svg>
      ) : (
        <svg viewBox="0 0 48 32" width="40" height="26" aria-hidden>
          <rect width="48" height="32" rx="4" fill="#E8ECF3" stroke="#C5CDDB" />
          <rect x="8" y="10" width="20" height="3" rx="1" fill="#9AA6BC" />
          <rect x="8" y="16" width="14" height="3" rx="1" fill="#B7C0D0" />
        </svg>
      )}
    </span>
  );
}
